import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'
class Toolbar extends React.Component {

  render() {

    const {
      classes,
      resetPinForDevices,
      toggleLock,
      toggleResetPin,
      toggleStolen,
      translate,
      device,
      isIdealAdmin,
      showModal,
      openRmaModal
    } = this.props

    const deviceType = device && device.systemdevicetype;
    let allowResetPin =
      deviceType &&
      resetPinForDevices &&
      resetPinForDevices.indexOf(deviceType) != -1 &&
      toggleResetPin;
    return (
      <div>
        {openRmaModal && (
          <Button className={classes.requestServiceButton} color="accent" onClick={() => openRmaModal()}>
            <Icon className={classes.requestServiceIcon}>build</Icon>
            {translate("device_details_request_service")}
          </Button>
        )}
        {isIdealAdmin && (
          <Tooltip title={translate("tooltip_search")}>
            <Button className={classes.button} color="accent" fab mini onClick={() => showModal()}>
              <Icon>search</Icon>
            </Button>
          </Tooltip>
        )}
        {allowResetPin && (<React.Fragment>
          <Tooltip title={translate("reset_pin")}>
            <Button className={classes.button} color="accent" fab mini onClick={() => toggleResetPin()}>
              <Icon>vpn_key</Icon>
            </Button>
          </Tooltip>
        </React.Fragment>
        )}
        {false && (<React.Fragment>
          <Tooltip title={translate("report_stolen_device")}>
            <Button className={classes.button} color="accent" fab mini onClick={() => toggleStolen()}>
              <Icon>pan_tool</Icon>
            </Button>
          </Tooltip>

          {!device.isstolen && (
            <Tooltip title={device.islocked ? (translate("unlock_device")) : (translate("lock_device"))}>
              <Button className={classes.button} color="accent" fab mini onClick={() => toggleLock()}>
                <Icon>{device.islocked ? 'lock' : 'lock_open'}</Icon>
              </Button>
            </Tooltip>
          )}
        </React.Fragment>)
        }
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
